import * as React from 'react';

export const withListItemRole = (child: React.ReactNode) => {
  if (React.isValidElement(child)) {
    return React.cloneElement(child as React.ReactElement<any, any>, { role: 'listitem' });
  }
  return child;
};
